module.exports = __webpack_public_path__ + "assets/img/decision-choisir-GED-Cartoucherie.863d47ef.jpg";